<template>
  <BatteryEmissionsAnalyzerTab
    :initial-fields="initialFields"
    :reports="reports"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import BatteryEmissionsAnalyzerTab from '~/components/sustainability/BatteryEmissionsAnalyzerTab.vue'
import { useSeo } from '~/composables/useSeo'
import { useReports } from '~/composables/useReports'
import type { TMarketServiceConfig } from '~/src/types/markets'
import type { TRecord } from '~/src/types/common'

const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: TRecord[]
}>()

const { getBatteryEmissionsAnalyserReports } = useReports()
const { getSeoInfo } = useSeo()

const seo = getSeoInfo({
  title: 'Battery Emissions Analyser',
  description:
    "Benchmark's Battery Emissions Analyser compares carbon emissions associated with battery cells with different chemistries, production locations and raw material sourcing.",
})

const { data, status } = await getBatteryEmissionsAnalyserReports(
  props.market.slug,
  'ESG_BATTERY_EMISSIONS_ANALYSER',
)

const loading = computed(() => status.value !== 'success')
const reports = computed(() => data.value || [])

definePageMeta({ isTab: true, layout: 'services' })
useHead(seo)
</script>
